module.exports = __webpack_public_path__ + "static/media/after-effects.0b052616.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/after-effects.png
// module id = 2542
// module chunks = 0